import { all } from 'redux-saga/effects'
import user from './user/sagas'
import menu from './menu/sagas'
import settings from './settings/sagas'
import programs from './programs/sagas'
import customers from './customers/sagas'
import partners from './partners/sagas'
import survey from './survey/sagas'
import promotions from './promotions/sagas'
import common from './common/sagas'
import cardDesign from './card-design/sagas'
import giftCardDesign from './gift-card-design/sagas'
import allowanceCardDesign from './allowance-card-design/sagas'
import brand from './brand/sagas'
import items from './items/sagas'
import post from './posts/sagas'
import customerGiftIssued from './customer-gifts-issued/sagas'
import customerGiftRedeemed from './customer-gifts-redeemed/sagas'
import subscription from './subscription/sagas'
import customerTags from './customer-tags/sagas'

export default function* rootSaga() {
  yield all([
    user(),
    menu(),
    settings(),
    programs(),
    customers(),
    partners(),
    common(),
    survey(),
    promotions(),
    cardDesign(),
    giftCardDesign(),
    allowanceCardDesign(),
    brand(),
    items(),
    post(),
    customerGiftIssued(),
    customerGiftRedeemed(),
    subscription(),
    customerTags(),
  ])
}
